export default [
  { title: "List envelope documents", icon: "", link: "/docs/list-envelope-document" },
  { title: "Download envelope documents", icon: "", link: "/docs/download-envelope" },
  { title: "Attach documents via binary transfer", icon: "", link: "/docs/attach-document" },
  { title: "Create a signable HTML document", icon: "", link: "/docs/create-signable" },
  { title: "Convert a PDF file into a signable HTML document", icon: "", link: "/docs/convert-pdf" },
];
